import { useInfoModal } from './useInfoModal';
import useIsMobile from '@/hooks/useIsMobile';
import DesktopInfoModal from './desktop';
import MobileInfoModal from './mobile';

const CustomerInfoModal = ({ id, open, onClose, onSave }) => {
  const isMobile = useIsMobile(768);
  const props = useInfoModal({ id, open, onClose, onSave });
  return isMobile ? <MobileInfoModal {...props} /> : <DesktopInfoModal {...props} />;
};

export default CustomerInfoModal;
